// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d196f35963d5a57fc8fc6367040cfdb4200ffdb9/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};